import classNames from 'classnames';
import { CSSProperties, ReactNode } from 'react';

import './ClickableDiv.scss';

export interface ClickableDivProps {
  onClick: React.DOMAttributes<HTMLDivElement>['onClick'];
  children?: ReactNode;
  className?: string;
  testId?: string;
  showPointer?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

export const ClickableDiv = ({
  onClick,
  children,
  className = '',
  testId = 'clickableDiv',
  disabled,
  showPointer = !disabled,
  style,
}: ClickableDivProps) => (
  <div
    className={classNames({
      'clickable-div': true,
      disabled,
      pointer: showPointer,
      [className]: !!className,
    })}
    data-testid={testId}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      if (disabled) return;
      onClick?.(e);
    }}
    role="button"
    aria-hidden
    style={style}
  >
    {children}
  </div>
);
